import { IconButton, Skeleton, Tooltip, Typography } from "@mui/material"
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { groupBy, sortByLocation } from "@shared/lib/utils";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { StyledAddCar } from "./AddCar.styled";
import { UseFormReturn } from "react-hook-form";
import { CarAdd } from "@models/car";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";
import { useTheme } from "@emotion/react";


interface AddCarProps {
  useForm: UseFormReturn<CarAdd>
  onBrowseCustomer?: () => void
}

function AddCar({ useForm, onBrowseCustomer }: AddCarProps) {

  const theme = useTheme();

  const { data: carStructure, isFetching } = useGetAccountStructureQuery("רכב");


  const structureSortedByTitle = groupBy(sortByLocation(carStructure), "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);


  return (
    <StyledAddCar>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && carStructure &&
        <>
          <div>
            <Typography variant="body1">פרטי רכב</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                if (!field.show_form) return null;

                if (field.field_name === "account_number") {
                  return (
                    <MuiInput
                      key={field.field_name}
                      field={field}
                      variant='outlined'
                      useForm={useForm}
                      showRequired
                      adornmentIcon={
                        <Tooltip title="בחירת לקוח מרשימת הלקוחות" placement="top">
                          <IconButton onClick={onBrowseCustomer} size="small" sx={{ color: theme.colors.main_color }}>
                            <AutoStoriesIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      }
                    />
                  );
                }

                return <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/>;
              })}
            </div>
          </div>

          <div>
            <Typography variant="body1">יצרן ודגם</Typography>
            <div className="fields">
              { structureSortedByTitle?.["יצרן ודגם"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddCar>
  )
}

export default AddCar